import React, { Component } from "react";
import { currentLocale } from "../locale";
import { connect } from "react-redux";
import { converter } from "../lib/converter";

class VerifyRecordedVideo extends Component {
  state = {
    videoToVerify: ""
  };
  // componentDidMount() {
  //   this.props.dispatch({ type: SET_VALID, payload: true });
  // }

  render() {
    return (
      <div className="columns">
        <div className="column">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title has-text-centered">
                {currentLocale.reviewRecording}
              </p>
            </header>
            <div className="card-content">
              <div className="content has-text-centered">
                {converter.convert(currentLocale.reviewRecording1)}
              </div>
            </div>
          </div>
        </div>
        <div className="column is-8">
          <article className="tile is-child box">
            <video style={{ width: "100%" }} src={this.props.video} controls />
          </article>
        </div>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  video: state.recording.url
});
const mapActionToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapActionToProps
)(VerifyRecordedVideo);
